const e = {
  name: "Ruler",
  dimensions: { width: 14, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 14 40" style="enable-background:new 0 0 14 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M8.2,35c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C7.7,33.7,8.2,34.3,8.2,35z"/>
		<path class="st0" d="M14,0H0v40h14V0z M2,38V2h10v3H8v2h4v3H8v2h4v3H8v2h4v3H8v2h4v3H8v2h4v3H8v2h4v6H2z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Ruler
};
